import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Row, Card, Col, Container, Button } from 'react-bootstrap';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

// Styles
import styles from '../../styles/components/Homepage/cards.module.scss';

export default function Cards() {
  const data = useStaticQuery(graphql`
    query {
      allContentfulNewsArticles {
        edges {
          node {
            title
            slug
            shortDescription {
              shortDescription
            }
            image {
              fluid(maxWidth: 600, quality: 100) {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `);

  const newsEvents = data.allContentfulNewsArticles.edges;

  return (
    <div className={styles.wrapper}>
      <Container className='my-5 py-md-5'>
        <Row className='g-5 mt-2'>
          {newsEvents.map(({ node }) => (
            <Col key={node.title} className={`d-table ${styles.cardWrapper}`}>
              <Card className={`d-table-cell ${styles.card}`}>
                <Link
                  to={`/news&events/${node.slug}`}
                  style={{ textDecoration: 'none' }}
                >
                  <div style={{ width: '100%', height: '300px' }}>
                    <Img
                      fluid={node.image.fluid}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                  <Card.Body className={`pt-5 ${styles.body}`}>
                    <Card.Title>
                      <div className='d-flex align-items-center mb-4'>
                        <h3
                          className={`${styles.title} mb-0 d-flex align-items-end`}
                        >
                          <strong>{node.title}</strong>
                        </h3>
                      </div>
                    </Card.Title>
                    <Card.Text className={`small ${styles.text}`}>
                      {node.shortDescription.shortDescription}
                    </Card.Text>
                  </Card.Body>
                </Link>

                <Card.Footer className={`p-0 ${styles.footer}`}>
                  <Link to={`/news&events/${node.slug}`}>
                    <Button
                      variant='card'
                      className='mt-auto'
                      style={{ width: '100%' }}
                    >
                      See More ...
                    </Button>
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
